import { all, put, call, takeEvery, takeLatest } from "redux-saga/effects";
import api_service from "../../network/api_callbacks";
import {
    GET_GAMES_REQUEST,
    getGamesSuccess,
    getGamesFailure,
    GET_GAME_REQUEST,
    getGameSuccess,
    getGameFailure,
    CREATE_GAME_REQUEST,
    createGameSuccess,
    createGameFailure,
    UPDATE_GAME_REQUEST,
    updateGameSuccess,
    updateGameFailure,
    DELETE_GAME_REQUEST,
    deleteGameSuccess,
    deleteGameFailure,
    releaseGameAnswerSuccess,
    releaseGameAnswerFailure,
    RELEASE_GAME_ANSWER_REQUEST,
    CLEAR_ALL,
    clearAll,
    GET_ANCHOR_CATEGORIES_REQUEST,
    getAnchorCategoriesRequest,
    getAnchorCategoriesSuccess,
    getAnchorCategoriesFailure
} from "../actions/getGameManagement";

function* getGamesSaga(action) {
    try {
        const page = action?.payload?.page || 1;
        const limit = action?.payload?.limit || 10;
        const response = yield call(api_service.getGames, page, limit);
        yield put(getGamesSuccess(response));
    } catch (err) {
        if (
            err?.code === 'ERR_NETWORK' ||
            err?.code === 'ERR_BAD_REQUEST' ||
            err?.code === 'ECONNABORTED'
        ) {
            yield put(getGamesFailure(err?.message || 'Network error'));
        } else {
            yield put(getGamesFailure(err?.response?.data?.message || 'Unknown error'));
        }
    }
}

function* getGameSaga(action) {
    try {
        const gameId = action?.payload?._id || '';
        const gameType = action?.payload?.type || '';
        const service = gameType === "FLReal" ? api_service.getFLRealGameDetails : api_service.getGame;
        const response = yield call(service, gameId);
        yield put(getGameSuccess(response));
    } catch (err) {
        if (
            err?.code === 'ERR_NETWORK' ||
            err?.code === 'ERR_BAD_REQUEST' ||
            err?.code === 'ECONNABORTED'
        ) {
            yield put(getGameFailure(err?.message || 'Network error'));
        } else {
            yield put(getGameFailure(err?.response?.data?.message || 'Unknown error'));
        }
    }
}

function* createGameSaga(action) {
    try {
        const gameId = action?.payload?._id || '';
        const gameType = action?.payload?.type || '';
        
        let response;
        if (gameType === "FLReal") {
            response = yield call(api_service.createFLRealGame, action.payload);
        } else {
            response = yield call(api_service.createGame, action.payload);
        }
        //const response = yield call(api_service.createGame, action.payload);
        yield put(createGameSuccess(response));
    } catch (err) {
        if (
            err?.code === 'ERR_NETWORK' ||
            err?.code === 'ERR_BAD_REQUEST' ||
            err?.code === 'ECONNABORTED'
        ) {
            yield put(createGameFailure(err?.message || 'Network error'));
        } else {
            yield put(createGameFailure(err?.response?.data?.message || 'Unknown error'));
        }
    }
}

function* updateGameSaga(action) {
    console.log("action", action)
    try {
        const gameId = action?.payload?._id || '';
        const gameType = action?.payload?.type || '';

        let response;
        if (gameType === "FLReal") {
            response = yield call(api_service.updateFLRealGame, gameId, action.payload);
        } else {
            response = yield call(api_service.updateGame, action.payload);
        }

        yield put(updateGameSuccess(response));
    } catch (err) {
        if (
            err?.code === 'ERR_NETWORK' ||
            err?.code === 'ERR_BAD_REQUEST' ||
            err?.code === 'ECONNABORTED'
        ) {
            yield put(updateGameFailure(err?.message || 'Network error'));
        } else {
            yield put(updateGameFailure(err?.response?.data?.message || 'Unknown error'));
        }
    }
}

function* deleteGameSaga(action) {
    try {
        const response = yield call(api_service.deleteGame, action?.payload);
        yield put(deleteGameSuccess(response));
    } catch (err) {
        if (
            err?.code === 'ERR_NETWORK' ||
            err?.code === 'ERR_BAD_REQUEST' ||
            err?.code === 'ECONNABORTED'
        ) {
            yield put(deleteGameFailure(err?.message || 'Network error'));
        } else {
            yield put(deleteGameFailure(err?.response?.data?.message || 'Unknown error'));
        }
    }
}

function* releaseAnswerGameSaga(action) {
    try {
        console.log("releaseAnswerGameSaga : ", action?.payload)
        const response = yield call(api_service.releaseAnswerGame, action?.payload);
        yield put(releaseGameAnswerSuccess(response));
    } catch (err) {
        if (
            err?.code === 'ERR_NETWORK' ||
            err?.code === 'ERR_BAD_REQUEST' ||
            err?.code === 'ECONNABORTED'
        ) {
            yield put(releaseGameAnswerFailure(err?.message || 'Network error'));
        } else {
            yield put(releaseGameAnswerFailure(err?.response?.data?.message || 'Unknown error'));
        }
    }
}

function* getAnchorCategoriesSaga(action) {
    try {
        console.log("getAnchorCategoriesSaga : ", action?.payload)
        const response = yield call(api_service.getAnchorCategory, action?.payload);
        yield put(getAnchorCategoriesSuccess(response));
    } catch (err) {
        if (
            err?.code === 'ERR_NETWORK' ||
            err?.code === 'ERR_BAD_REQUEST' ||
            err?.code === 'ECONNABORTED'
        ) {
            yield put(getAnchorCategoriesFailure(err?.message || 'Network error'));
        } else {
            yield put(getAnchorCategoriesFailure(err?.response?.data?.message || 'Unknown error'));
        }
    }
}


// function* clearAllGameSaga(action) {
//     yield put(clearAll(action));
// }

export default function* watchGetGameManagementSaga() {
    yield all([
        takeEvery(GET_GAMES_REQUEST, getGamesSaga),
        takeEvery(GET_GAME_REQUEST, getGameSaga),
        takeEvery(CREATE_GAME_REQUEST, createGameSaga),
        takeEvery(UPDATE_GAME_REQUEST, updateGameSaga),
        takeEvery(DELETE_GAME_REQUEST, deleteGameSaga),
        takeEvery(RELEASE_GAME_ANSWER_REQUEST, releaseAnswerGameSaga),
        takeEvery(GET_ANCHOR_CATEGORIES_REQUEST, getAnchorCategoriesSaga)
        //takeEvery(CLEAR_ALL,clearAllGameSaga)
    ]);
}